import { ReactElement } from "react";

export type Tag = { label: string; iconName: string };
export type FeaturePreview = { label: string; icon: ReactElement };
export type GuestTypeImage = { [key: string]: ReactElement };
export type SpaceFeatureIcons = { [key: string]: string };
export type GuestPassionImage = { [key: string]: ReactElement };
export type SharePlatformsConfigProps = (text?: string) => {
  href: string;
  "data-action"?: string;
};

export type GuestsTypology = { count: number; type: string };
export type GuestsInterest = { count: number; interest: string };
export type SpaceImage = string;
export type SpaceId = string;
export type Feature = string;
export type SpaceAccessibility = string;
export type SpaceRule = string;
export type BuildingService = string;

export type FeatureIcon = ReactElement;

export enum FilterType {
  Checkbox = "Checkbox",
  Radio = "Radio",
  Toggle = "Toggle",
}

export type Affinity = number | null;

export interface SpaceFiltersValues {
  [key: string]: string[];
}

export interface ComponentFilterProps {
  filterName: string;
  filtersSelected?: string[];
  options: string[];
  onChangeFilters: (filterName: string, option: string) => void;
}

export interface SpaceFilter {
  name: string;
  type: FilterType;
  options: string[];
  isMultiChoice: boolean;
}

export interface CurrentGuest {
  type: string;
  interests: string[];
}

export interface BuildingDetails {
  address: string;
  complex: string;
  id: string;
  name: string;
  zone: string | null;
}

export interface MainFeatures {
  bathroom: number;
  bedroom: number;
  openPlanKitchen: boolean;
  rooms: number;
  typology: string;
}
export interface SpaceEntity {
  id: SpaceId;
  address: string;
  name: string;
  floor: number;
  bathroom: string;
  tags: Tag[];
  images: SpaceImage[] | null;
  price: number;
  maxGuestsNumber: number;
  currentGuests: CurrentGuest[];
  affinity: Affinity;
  firstAvailability: string | null;
  features: Feature[];
  accessibility: SpaceAccessibility[];
  rules: SpaceRule[];
  buildingServices: BuildingService[];
  typologyName?: string;
  buildingDetails: BuildingDetails;
  available: boolean;
  sidesName: string[];
  mainFeatures: MainFeatures;
}
